"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by david.shadunts on 11/7/2017.
 */
var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus[NotificationStatus["FAILURE"] = 0] = "FAILURE";
    NotificationStatus[NotificationStatus["SUCCESS"] = 1] = "SUCCESS";
    NotificationStatus[NotificationStatus["NO_MODIFICATION"] = 2] = "NO_MODIFICATION";
    NotificationStatus[NotificationStatus["ENTITY_LOCKED"] = 3] = "ENTITY_LOCKED";
    NotificationStatus[NotificationStatus["ENTITY_NOT_FOUND"] = 4] = "ENTITY_NOT_FOUND";
    NotificationStatus[NotificationStatus["SERVICE_UNAVAILABLE"] = 5] = "SERVICE_UNAVAILABLE";
    NotificationStatus[NotificationStatus["FORBIDDEN"] = 6] = "FORBIDDEN";
})(NotificationStatus = exports.NotificationStatus || (exports.NotificationStatus = {}));
//# sourceMappingURL=notification-status.js.map